<template>
  <div
    class="rounded border text-sm w-full flex flex-col py-3 px-3"
    :class="{
      'bg-yellow-100 border-yellow-300': selected,
      'cursor-pointer hover:border-gray-400': !selected,
    }"
    @click="$emit('click')"
  >
    <span class="py-2" :class="{ 'font-semibold': selected }">
      {{ program.name }}
    </span>
    <span :class="{ 'text-gray-200': !selected }">
      Applications: {{ program.applications.answered }}
    </span>
    <span :class="{ 'text-gray-200': !selected }">
      Created at: {{ program.created_at | date }}
    </span>
    <Button
      v-if="selected"
      class="hover:bg-gray-50 hover:text-black w-48 my-2"
      :class="{ 'text-gray-200': !selected }"
      @click.prevent="openConfig()"
    >
      Configure questions
    </Button>
    <el-dialog
      title="Program configuration"
      :visible.sync="isProgramConfigDialogOpen"
      :close-on-click-modal="false"
      append-to-body
    >
      <EventEditorProgramFieldConfig @close="closeConfig()" />
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Button from 'components/common/Button.vue'
import TextButton from 'components/common/TextButton.vue'
import EventEditorProgramFieldConfig from './EventEditorProgramFieldConfig.vue'

export default {
  components: {
    Button,
    TextButton,
    EventEditorProgramFieldConfig,
  },
  props: {
    program: {
      type: Object,
      required: true,
    },
    selected: Boolean,
  },
  data() {
    return {
      isProgramConfigDialogOpen: false,
    }
  },
  computed: {
    ...mapState({
      programDetails: (state) => state.organizationProgramDetails.program,
      alreadyFetched: (state) =>
        state.organizationProgramDetails.alreadyFetched,
    }),
    type() {
      return this.selected ? 'primary' : 'default'
    },
  },
  methods: {
    openConfig() {
      this.isProgramConfigDialogOpen = true
      if (!this.alreadyFetched || this.programDetails.id !== this.program.id) {
        this.$store.dispatch('organizationProgramDetails/fetch', {
          organizationId: this.program.organization_id,
          programId: this.program.id,
        })
      }
    },
    closeConfig() {
      this.isProgramConfigDialogOpen = false
    },
  },
}
</script>
